import CF from './common-functions';
import CarsInfo from './cars-info';

const prices = CarsInfo.CARS.filter(el => el.price).map(el => el.price);
const advantages = CarsInfo.CARS.filter(el => el.advantage).map(el => el.advantage);
const payments = CarsInfo.CARS.filter(el => el.payment).map(el => el.payment);
const MAX_ADVANTAGE = Math.max(...advantages);
const MIN_PRICE = Math.min(...prices);
const MIN_PAYMENT = Math.min(...payments);

let date = CF.getNextDate();


let d = new Date();
let year = d.getFullYear();
let month = d.getMonth();
let new_date = new Date(year, month+1, 0)
let disclaimer_date = `${new_date.getDate().toString().padStart(2, '0')}.${(month+1).toString().padStart(2, '0')}.${year}`;


const PHONE = '+7 (495) 785-19-94'.replace(/\s/g, '\u00A0').replace(/-/g, '\u2011');

const PHONE_RAW = PHONE.replace(/\D+/g, "");


const today = new Date();
const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

const disc_start_date = `01.${(+today.getMonth() + 1 < 10) ? '0' : '' }${today.getMonth() + 1}.${today.getFullYear()}`;
const disc_end_date = `${lastDay.getDate()}.${(+today.getMonth() + 1 < 10) ? '0' : '' }${today.getMonth() + 1}.${today.getFullYear()}`;

export default {
    phone: PHONE,
    phone_raw: PHONE_RAW,
    full_promo_condition: {
        first_part: `
        *Предложение не является публичной офертой, предложение ограничено и действует с ${disc_start_date}г. по ${disc_end_date}г. Автомобили Mitsubishi по ценам 2017 года – цены достигаются за счет предоставления выгод по программе трейд-ин и покупке автомобиля в кредит. Полные условия акции можно уточнить у продавцов-консультантов дилерского центра РОЛЬФ по телефону <a href="tel:${PHONE_RAW}">${PHONE}</a>.
        `,
        second_part: `
        Данный сайт носит исключительно информационно-справочный характер, не является публичной офертой.
        <br /><br />
        `,
        third_part: `
        Подробности акции по телефону <a href="tel:${PHONE_RAW}">${PHONE}</a> и в дилерском центре РОЛЬФ.
        `,
        fourth_part: `
        ** Условие покупки автомобиля Mitsubishi без первоначального взноса означает покупку автомобиля по программе трейд-ин, где автомобиль идет в счет первоначального взноса за новый автомобиль Mitsubishi. Полные условия акции можно уточнить у продавцов-консультантов дилерского центра РОЛЬФ по телефону <a href="tel:${PHONE_RAW}">${PHONE}</a>.
        `,
        fifth_part: '** Указанная маркетинговая ставка 0% не равна процентной ставке банка. В этом случае затраты покупателя на финансирование кредита обеспечиваются за счет соразмерного снижения цены автомобиля. Предложение действует при оформлении услуги «Защита платежей» (договор страхования жизни и трудоспособности) и полиса КАСКО на полную стоимость кредита в любой страховой компании из перечня, размещенного на сайте Банка. Услуга «Защита платежей» - договор страхования жизни и утраты трудоспособности, который может быть заключен Заемщиком с любой страховой компанией из перечня, размещенного на официальном сайте Банка. Страхование должно быть оформлено на весь срок кредита по рискам утраты жизни и постоянной потери трудоспособности по любой причине. Страховая сумма должна быть равна сумме кредита. В счет первоначального взноса по рассрочке клиент сдает свой автомобиль. Предложение не является публичной офертой. Подробности по телефону дилерских центров РОЛЬФ +7 (495) 785‑19‑94'
    },
    end_date: date,
    max_advantage: MAX_ADVANTAGE,
    min_price: MIN_PRICE,
    min_payment: MIN_PAYMENT,
    offices: [
        {
            name: 'Рольф',
            address: 'Московская обл., г.Химки, Ленинградское шоссе, вл.№21',
            postal_code: 141410,
            phone: PHONE,
            phone_raw: PHONE_RAW,
            worktime: {
                from: '08:00',
                to: '22:00'
            },
            INN: "5047059383",
            KPP: "772845002",
            OGRN: "1045009553577",
            coords: {
                x: 37.603359,
                y: 55.768500
            }
        }
    ],
    watchers: 23,
    brand: 'Mitsubishi',
    center_coords: {
        x: 37.394964,
        y: 55.906757
    },
    need_agreement: true,
    cKeeper: undefined,
    need_manager_phone: true,
    email_coupon: true
}